import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import RootState from '@vue-storefront/core/types/RootState'
import CategoryState from '../../types/CategoryState'

export const categoryModule: Module<CategoryState, RootState> = {
  namespaced: true,
  state: {
    loading: true,
    loadingCount: 0,
    list: [],
    current: {},
    filters: {
      available: {},
      chosen: {}
    },
    breadcrumbs: {
      routes: []
    },
    current_product_query: null,
    current_path: [], // list of categories from root to current
    partner_tree: {
      code: null,
      tree: []
    },
    tree_loading: false,
    discounted_products: [],
    total_discounted_products: 0
  },
  getters,
  actions,
  mutations
}
